import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      width: '100%',
      flexFlow: 'row nowrap',
      gap: theme.spacing(1),
    },
    assetIcon: {
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(20),
    },
    content: {
      minWidth: 0,
      flex: 1,
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(0.25),
    },
    label: {
      color: COLORS.gray.black,
    },
    body: {
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'MenuItemBank' }
);
